// Smart selection for comparison plans (SFC reviews).
// Picking a base plan auto-picks the plan it is normally reviewed against.
export const ComparisonPlanMap = {
    'Effective': 'Duplicate Effective',
    'Duplicate Effective': 'Corrected Effective',
    'Corrected Effective': 'Revised',
}

// A floodway run carries an FW (encroachment) profile; a multiple-profile run
// does not. Base and comparison plans have to agree on this: an Effective FW
// pairs with a Duplicate Effective FW, not with a multiple-profile one.
export const isFloodwayPlan = (plan) => {
    if (plan?.type === 'Floodway Run')
        return true

    return plan?.mapProfiles?.some(x => x.target === 'FW') === true
}

const matchRiver = (plan, baseRiver) => {
    const rivers = plan?.rivers || []
    if (rivers.length === 0)
        return undefined

    const same = baseRiver && rivers.find(x => x.key === baseRiver.key)

    return {...(same || rivers[0])}
}

// Returns the selection side ({projectId, planId, river, survey}) for the plan
// that should be compared against basePlan, or null when there is no rule for
// the base plan type or no matching plan was uploaded.
export const findComparisonSide = ({projects, baseProjectId, basePlan, baseRiver}) => {
    const targetType = ComparisonPlanMap[basePlan?.type]
    if (!targetType || !projects?.length)
        return null

    const baseIsFloodway = isFloodwayPlan(basePlan)

    const candidates = []
    projects.forEach(project => {
        (project?.projectFiles || []).forEach(plan => {
            if (plan?.type !== targetType)
                return

            candidates.push({
                project,
                plan,
                // An FW/multiple match matters more than which model the plan
                // lives in; a plan from the other model only breaks the tie.
                score: (isFloodwayPlan(plan) === baseIsFloodway ? 2 : 0)
                    + (project?.id !== baseProjectId ? 1 : 0)
            })
        })
    })

    if (candidates.length === 0)
        return null

    const best = candidates.reduce((a, b) => (b.score > a.score ? b : a))
    const surveys = best.project?.shapeFiles?.filter(x => x.hasSurveyData)

    return {
        projectId: best.project?.id,
        planId: best.plan?.id,
        river: matchRiver(best.plan, baseRiver),
        survey: {...(surveys?.length > 0 ? surveys[0] : {})},
    }
}
